import { TRANSFORMATION_TYPES } from 'constants/MediaConstants';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = {};

const setClipping = (state, { meta = {} }) => {
  const hasClipping = meta?.transformations.includes(TRANSFORMATION_TYPES.CLIPPING);
  if (hasClipping) {
    return { ...state, [meta?.mediaId]: true };
  }
  return state;
};

export default createReducer(initialState, {
  [actionTypes.APPLY_TRANSFORMATIONS_SUCCESS]: setClipping,
});
